/**
 * 樂觀新增的臨時項目（id 為 temp-…，API 成功後換成真實資料）
 * 送出到完成之間半透明、不能點：點名稱會進到不存在的頁面，編輯／刪除也會打到不存在的 id
 */
export const pendingRowClass = (item: { id: string }) =>
  item.id.startsWith('temp-') ? 'opacity-60 pointer-events-none' : '';
